import type * as Types from 'app/types/graphql';

export type PathAnalyticSelectFragment = {
  pathGroups?: Types.Maybe<
    Array<
      Types.Maybe<{
        paths?: Types.Maybe<
          Array<
            Types.Maybe<
              Pick<
                Types.PathAnalytic,
                | 'level'
                | 'locationPath'
                | 'id'
                | 'parentID'
                | 'pageType'
                | 'shopifyPageID'
                | 'pageTitle'
              > & {
                metric?: Types.Maybe<
                  Pick<
                    Types.PathAnalyticMetric,
                    | 'totalPageViewed'
                    | 'totalVisitors'
                    | 'totalClicked'
                    | 'totalAddedToCart'
                    | 'totalReachedCheckout'
                    | 'totalOrders'
                    | 'totalSessions'
                    | 'totalSessionsThatCompletedCheckout'
                    | 'totalSessionsThatReachedCheckout'
                    | 'totalSessionsWithCartAdditions'
                    | 'totalClickedHasHref'
                    | 'totalSessionsWithoutAction'
                    | 'totalContinuationSession'
                  >
                >;
              }
            >
          >
        >;
      }>
    >
  >;
};

export type PathAnalyticGroupSelectFragment = {
  paths?: Types.Maybe<
    Array<
      Types.Maybe<
        Pick<
          Types.PathAnalytic,
          'level' | 'locationPath' | 'id' | 'parentID' | 'pageType' | 'shopifyPageID' | 'pageTitle'
        > & {
          metric?: Types.Maybe<
            Pick<
              Types.PathAnalyticMetric,
              | 'totalPageViewed'
              | 'totalVisitors'
              | 'totalClicked'
              | 'totalAddedToCart'
              | 'totalReachedCheckout'
              | 'totalOrders'
              | 'totalSessions'
              | 'totalSessionsThatCompletedCheckout'
              | 'totalSessionsThatReachedCheckout'
              | 'totalSessionsWithCartAdditions'
              | 'totalClickedHasHref'
              | 'totalSessionsWithoutAction'
              | 'totalContinuationSession'
            >
          >;
        }
      >
    >
  >;
};

export type PathAnalyticPageSelectFragment = Pick<
  Types.PathAnalytic,
  'level' | 'locationPath' | 'id' | 'parentID' | 'pageType' | 'shopifyPageID' | 'pageTitle'
> & {
  metric?: Types.Maybe<
    Pick<
      Types.PathAnalyticMetric,
      | 'totalPageViewed'
      | 'totalVisitors'
      | 'totalClicked'
      | 'totalAddedToCart'
      | 'totalReachedCheckout'
      | 'totalOrders'
      | 'totalSessions'
      | 'totalSessionsThatCompletedCheckout'
      | 'totalSessionsThatReachedCheckout'
      | 'totalSessionsWithCartAdditions'
      | 'totalClickedHasHref'
      | 'totalSessionsWithoutAction'
      | 'totalContinuationSession'
    >
  >;
};

export type PathAnalyticMetricSelectFragment = Pick<
  Types.PathAnalyticMetric,
  | 'totalPageViewed'
  | 'totalVisitors'
  | 'totalClicked'
  | 'totalAddedToCart'
  | 'totalReachedCheckout'
  | 'totalOrders'
  | 'totalSessions'
  | 'totalSessionsThatCompletedCheckout'
  | 'totalSessionsThatReachedCheckout'
  | 'totalSessionsWithCartAdditions'
  | 'totalClickedHasHref'
  | 'totalSessionsWithoutAction'
  | 'totalContinuationSession'
>;

export type PathAnalyticDeviceSelectFragment = Pick<Types.DeviceStats, 'type' | 'totalCount'>;

export type PathAnalyticChannelSelectFragment = Pick<Types.ChannelStats, 'type' | 'totalCount'>;

export const PathAnalyticMetricSelectFragmentDoc = `
    fragment PathAnalyticMetricSelect on PathAnalyticMetric {
  totalPageViewed
  totalVisitors
  totalClicked
  totalAddedToCart
  totalReachedCheckout
  totalOrders
  totalSessions
  totalSessionsThatCompletedCheckout
  totalSessionsThatReachedCheckout
  totalSessionsWithCartAdditions
  totalClickedHasHref
  totalSessionsWithoutAction
  totalContinuationSession
}
    `;
export const PathAnalyticPageSelectFragmentDoc = `
    fragment PathAnalyticPageSelect on PathAnalytic {
  level
  locationPath
  id
  parentID
  pageType
  shopifyPageID
  pageTitle
  metric {
    ...PathAnalyticMetricSelect
  }
}
    `;
export const PathAnalyticGroupSelectFragmentDoc = `
    fragment PathAnalyticGroupSelect on PathGroups {
  paths {
    ...PathAnalyticPageSelect
  }
}
    `;
export const PathAnalyticSelectFragmentDoc = `
    fragment PathAnalyticSelect on PathAnalytics {
  pathGroups {
    ...PathAnalyticGroupSelect
  }
}
    `;
export const PathAnalyticDeviceSelectFragmentDoc = `
    fragment PathAnalyticDeviceSelect on DeviceStats {
  type
  totalCount
}
    `;
export const PathAnalyticChannelSelectFragmentDoc = `
    fragment PathAnalyticChannelSelect on ChannelStats {
  type
  totalCount
}
    `;
